export const KNOWLEDGEBASE_TASK = 'data_collection_tlr_no';
export const NEUROPROFILER_TASK = 'neuroprofiler';
export const ANNUAL_REVIEW_PREPERATION_TASK = 'annualreviewpreparation';
